import { Button } from "@/components/core/buttons/button";
import type React from "react";

interface SalespersonDetailsModalProps {
	salesperson: {
		salesperson: {
			id: number;
			name: string;
			email: string;
		};
		total_contracts: number;
		total_monthly_sales: number;
		total_contract_value: number;
		total_royalty_amount: number;
	};
}

export const SalespersonDetailsModal: React.FC<SalespersonDetailsModalProps> = ({ salesperson }) => {
	const formatCurrency = (value: number) => {
		return new Intl.NumberFormat("en-PH", {
			style: "currency",
			currency: "PHP",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(value);
	};

	return (
		<div className="space-y-4">
			<div className="bg-gray-50 p-4 rounded-lg">
				<h3 className="text-lg font-semibold mb-2">{salesperson.salesperson.name}</h3>
				<p className="text-sm text-gray-600">{salesperson.salesperson.email}</p>
			</div>

			<div className="grid grid-cols-2 gap-4">
				<div className="text-center p-4 bg-blue-50 rounded-lg">
					<p className="text-sm text-gray-600">Total Contracts</p>
					<p className="text-2xl font-bold text-blue-600">{salesperson.total_contracts}</p>
				</div>
				<div className="text-center p-4 bg-green-50 rounded-lg">
					<p className="text-sm text-gray-600">Monthly Sales</p>
					<p className="text-2xl font-bold text-green-600">{formatCurrency(salesperson.total_monthly_sales)}</p>
				</div>
				<div className="text-center p-4 bg-purple-50 rounded-lg">
					<p className="text-sm text-gray-600">Total Contract Value</p>
					<p className="text-2xl font-bold text-purple-600">{formatCurrency(salesperson.total_contract_value)}</p>
				</div>
				<div className="text-center p-4 bg-amber-50 rounded-lg">
					<p className="text-sm text-gray-600">Total Royalty Amount</p>
					<p className="text-2xl font-bold text-amber-600">{formatCurrency(salesperson.total_royalty_amount)}</p>
				</div>
			</div>
		</div>
	);
};
